import React, { ChangeEvent, FormEvent, ReactElement, useState } from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

import { ProjectTask, ProjectTaskTimelog, useProjects } from ".";

interface IProps {
	task: ProjectTask;
}

export const ProjectTaskTimelogForm = (props: IProps): ReactElement => {
	const [submitDisabled, setSubmitDisabled] = useState(true);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [timelog, setTimelog] = useState(new ProjectTaskTimelog());
	const projectContext = useProjects();

	const handleSubmit = async (event: FormEvent): Promise<void> => {
		event.preventDefault();
		setIsSubmitting(true);

		try {
			await projectContext.logTimeOnTask!(props.task, timelog);
			setTimelog(new ProjectTaskTimelog());
			toast.success("Time has been logged.");
		} catch (error) {
			toast.error("Failed to log time. Please try again.");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Form onSubmit={handleSubmit}>
			<Form.Group>
				<Form.Label>Hours Spent</Form.Label>
				<Form.Control
					type="number"
					value={String(timelog.hours)}
					onChange={(event: ChangeEvent<HTMLInputElement>) => {
						const hours = parseFloat(event.target.value);
						setTimelog(prevState => {
							prevState.hours = hours;
							return { ...prevState };
						});

						if (timelog.hours != null) {
							setSubmitDisabled(false);
						} else {
							setSubmitDisabled(true);
						}
					}}
				/>
			</Form.Group>
			<Form.Group>
				<Form.Label> Date </Form.Label>
				<DatePicker
					className="form-control"
					selected={timelog.logDate}
					onChange={(date: Date | null) => {
						setTimelog(prevState => {
							if (date) {
								prevState.logDate = date;
							}
							return { ...prevState };
						});
					}}
				/>
			</Form.Group>
			<Form.Group>
				<Form.Label>Short Comment</Form.Label>
				<Form.Control
					type="text"
					value={timelog.description}
					onChange={(event: ChangeEvent<HTMLInputElement>) => {
						const description = event.target.value;
						setTimelog(prevState => {
							prevState.description = description;
							return { ...prevState };
						});
					}}
				/>
			</Form.Group>
			<Button type="submit" disabled={submitDisabled || isSubmitting} variant="primary">
				{isSubmitting ? "Logging..." : "Log time"}
			</Button>
		</Form>
	);
};
